import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from '@fluentui/react-components';
import { tokens } from './tokens.js';
const useStyles = makeStyles({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalXS,
        minWidth: 0,
    },
    dot: {
        flexShrink: 0,
        width: '8px',
        height: '8px',
        borderRadius: '50%',
    },
    label: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightRegular,
        whiteSpace: 'nowrap',
    },
});
/**
 * A state, drawn the way the approved 06b frames draw one: a small coloured dot followed by
 * plain text — NOT a filled or outlined pill.
 *
 * Every status in those frames reads this way: `● Not started`, `● Candidate`, `● Ready`,
 * `● In 16 days`. The build used Fluent's tinted `Badge` instead, which puts a coloured block
 * behind the words. It was the single largest reason the screens did not look like the design,
 * because a status appears on nearly every one of them.
 *
 * The dot is `aria-hidden`: it repeats what the label already says, and announcing "circle"
 * before every status would be noise. Meaning therefore never rests on colour alone, which is
 * what a bare dot would otherwise risk (WCAG 1.4.1).
 *
 * This is for STATE. Tag-style chips — "Separate file", "One-off", "Restricted" — keep their
 * outline treatment; the frames draw those as chips and they are not statuses.
 */
export function StatusDot({ color, children }) {
    const styles = useStyles();
    return (_jsxs("span", { className: styles.root, children: [_jsx("span", { className: styles.dot, style: { backgroundColor: color }, "aria-hidden": "true" }), _jsx("span", { className: styles.label, children: children })] }));
}
//# sourceMappingURL=StatusDot.js.map